module.exports = __webpack_public_path__ + "img/84000.74c042f5.jpg";